import {useRef} from 'react'
import { TextField, Button, Box } from '@mui/material';

export default function Contact(){
    const SENDGRID_API = 'https://dotnetfuncs11222022.azurewebsites.net/api/HttpTriggerInPortal?code=23SrXVNtCfdtZbTSq-h5QQN9IwLNRuB6N97Q6-ji-sdDAzFumd6qNg==';
    const nameRef =  useRef(null)
    const emailRef = useRef(null)
    const messageRef =  useRef(null)
    const handleSubmit = (event) => {
        event.preventDefault()
  
        const data = {
              name: nameRef.current.value,
              email: emailRef.current.value,
              message: messageRef.current.value
              }

        fetch(SENDGRID_API, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(
            (response) => {
            alert("Message Sent.");
            resetForm()},
            (error)=>{
            alert("Message failed to send.")
        });
    }

    const resetForm = () => {
        nameRef.current.value="";
        emailRef.current.value="";
        messageRef.current.value="";
    }
  
    return(
    <Box class = "form-group">
        <Box component="form" 
            onSubmit={handleSubmit} 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            p={4}>
            <h1>Contact Form using Twilio SendGrid</h1>
            <TextField
                label="Name"
                name="name"
                variant="outlined"
                placeholder='Name'
                sx={{width: 640}}
                inputRef={nameRef}
                margin="normal"
            />
            <TextField
                label="Email"
                name="email"
                variant="outlined"
                placeholder='email'
                sx={{width: 640}}
                inputRef={emailRef}
                margin="normal"
            />
            <TextField
                label="Message"
                name="message"
                multiline
                placeholder='Message here'
                rows={4}
                variant="outlined"
                sx={{width: 640}}
                inputRef={messageRef}
                margin="normal"
            />
            <Button 
            type="submit"
            color="primary"
            variant="contained"
            sx={{ mt: 3 }}>
                Submit
            </Button>            
        </Box>

      </Box>
    )
}